import $ from 'jquery';

const $accordionEl = $('.accordion');

$(function () {
    if ($accordionEl.length > 0) {
        $accordionEl.each(function () {
            accordion($(this));
        });
    }
});

const accordion = (accordionEl) => {
    accordionEl.on('click', function () {
        toggleAccordion(accordionEl);
    });
};

const toggleAccordion = (accordionEl) => {
    if (accordionEl.hasClass('active')) {
        accordionEl.removeClass('active').one('transitionend', function () {
            accordionEl.find('.accordion__text').slideUp(300);
        });
    } else {
        accordionEl.find('.accordion__text').slideDown(300, function () {
            accordionEl.addClass('active');
        });
    }
};
